import { StaticBaseDao } from '@/dao';
import { GPIOReading } from '@/objects/generated';

export class GPIOReadingDao extends StaticBaseDao {
    public static async SaveGunstartGPIOReadingForGroupStart(
        EventID: number,
        GroupID: number,
        reading: GPIOReading,
    ): Promise<GPIOReading | null> {
        return this.BaseFetch(
            GPIOReading,
            `GPIOReading/SaveGunstartReadingForGroupStart` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (GroupID == undefined ? '' : `GroupID=${GroupID}`),
            'POST',
            reading,
        );
    }
}
